// React/finance-app/src/features/tt-insights/utils.js
export const fmtDate = (d) => {
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const money = (n) => {
  if (n === null || n === undefined || Number.isNaN(n)) return '£0.00';
  const num = Number(n);
  // Explicitly format as GBP with £ symbol, ensuring it always uses £ not $
  const formatted = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
  // Ensure £ is used (replace any $ that might appear due to browser locale issues)
  return formatted.replace(/\$/g, '£');
};

// alias for consistency across tabs
export const fmtMoney = money;
